import React, { Component } from 'react'
import {
  IconNotification,
  IconExport,
  IconUser,
  IconFile,
  IconDown,
  IconLock,
  IconSwap,
  IconUserGroup
} from '@arco-design/web-react/icon'
import {
  Layout,
  PageHeader,
  Button,
  Space,
  Avatar,
  Badge,
  Divider,
  Typography,
  Link,
  Dropdown,
  Menu,
  Message,
  Affix,
  Trigger
} from '@arco-design/web-react'
import routes from 'router/index'
import history from 'common/utils/history'
import default_avart from 'asserts/default_avater.png'

import './header.scss'
const Header = Layout.Header
const iconStyle = {
  fontSize: 12
}
const setTitle = (title) => {
  let replaceList = [
    '/myapp/addmyapp',
    '/enginefactory/model/add',
    '/enginefactory/model/management/add',
    '/enginefactory/dataset/add'
  ]
  const urlParams = new URL(window.location.href)
  const pathname = urlParams?.pathname
  if (!replaceList.includes(pathname)) {
    localStorage.setItem('title', title)
  }
}

function setvisibleUpgrade(event) {
  event.stopPropagation()
  history.push('/privilege')
  history.go()
}
function goJump(value) {
  history.push(value)
  window.location.reload()
}
const userinfo = JSON.parse(localStorage.getItem('userinfo'))
function Popup() {
  return (
    <div
      className="demo-trigger-popup"
      style={{ width: 272 }}
      onClick={() => goJump('/authentication')}
    >
      <div className="see-vip">
        <div
          className="AlibabaPuHuiTi-Medium"
          style={{ color: '#936500', fontSize: 16, marginBottom: 2 }}
        >
          开通韦尼克企业尊享版
        </div>
        <div>享受企业会员专属特权，释放AI创作价值</div>
        <button
          className="Upgrade-btn Upgrade-svp AlibabaPuHuiTi-Medium"
          onClick={() => goJump('/authentication')}
        >
          立即升级
        </button>
      </div>
    </div>
  )
}
class Headers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      count: props.count,
      dot: props.dot,
      username: props.username,
      avatar: props.avatar,
      showback: false,
      title: '',
      current: '',
      openKeys: [],
      menuList: routes[0].children,
      extraBreadcrumbItems: null,
      listMapUrl: [],
      pathSnippets: null,
      identity: props.identity,
      has_enterprise: props.has_enterprise,
      vip_level: props.vip_level,
      isopenDown: false,
      istrigger: false,
      visible: false,
      visible2: false
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      count: nextProps.count,
      dot: nextProps.dot,
      username: nextProps.username,
      avatar: nextProps.avatar,
      identity: nextProps.identity,
      has_enterprise: nextProps.has_enterprise,
      vip_level: nextProps.vip_level
    })
  }
  UNSAFE_componentDidUpdate(prevProps, prevState) {}
  componentDidMount() {
    document.addEventListener('click', this.HeadersAllMenu)
    this.HeadersAllMenu()
    this.checkHome()
  }
  componentWillUnmount() {
    //在组件卸载及销毁之前直接调用
    document.removeEventListener('click', this.HeadersAllMenu)
  }
  initkey(key) {
    let nowkey = this.sliceURL(key)
    this.state.openKeys = nowkey
    this.state.current = key
    this.setState({
      openKeys: nowkey
    })
  }
  checkHome() {
    // 获取当前 URL 的参数
    const urlParams = new URLSearchParams(window.location.search)
    const type = urlParams.get('type')
    // 获取 ID 为 layoutHeaders 的元素
    // 检查参数 type 是否等于 'home'
    if (type === 'home') {
      const layoutHeaders = document.getElementById('layoutHeaders')
      if (layoutHeaders) {
        // 获取类名为 arco-page-header-head-main-with-back 的子元素
        const targetElement = layoutHeaders.querySelector(
          '.arco-page-header-head-main'
        )
        if (targetElement) {
          // 设置透明度为 0
          targetElement.style.opacity = '0'
        }
      }
    } else {
      const layoutHeaders = document.getElementById('layoutHeaders')
      if (layoutHeaders) {
        // 获取类名为 arco-page-header-head-main-with-back 的子元素
        const targetElement = layoutHeaders.querySelector(
          '.arco-page-header-head-main'
        )

        if (targetElement) {
          // 设置透明度为 0
          targetElement.style.opacity = '1'
        }
      }
    }
  }
  sliceURL(key) {
    let listmap = key.split('/').filter((i) => i)
    let nowkey = listmap.map((_, index) => {
      let url = `/${listmap.slice(0, index + 1).join('/')}`
      return url
    })
    return nowkey
  }
  arrtojson() {
    this.formap(routes[0].children)
    let obj = {}
    this.state.listMapUrl.map((item, index) => {
      obj[item.path] = item.title
      return obj
    })
    return obj
  }
  formap(list) {
    const urlParams = new URL(window.location.href)
    const pathname = urlParams?.pathname
    list.map((pre, item) => {
      if (!pre.children) {
        this.state.listMapUrl.push({ path: pre.path, title: pre.title })
        if (pre.path === pathname) {
          setTitle(pre.title)
        }
      } else {
        this.formap(pre.children)
        if (pre.path === pathname) {
          setTitle(pre.title)
        }
      }
    })
  }
  setTitle() {
    let HistoryList = JSON.parse(localStorage.getItem('HistoryList'))
    let location = history.location
    if (HistoryList && HistoryList.length > 1) {
      if (
        HistoryList[HistoryList.length - 2].url ===
        HistoryList[HistoryList.length - 1].url
      ) {
        if (location.pathname === '/myapp/addmyapp') {
          return HistoryList[HistoryList.length - 2].title
        } else {
          return HistoryList[HistoryList.length - 2].title
        }
      } else {
        return HistoryList[HistoryList.length - 2].title
      }
      // return HistoryList[HistoryList.length - 2].title
    }
  }

  handleSetTitle(val) {
    let str = val
    let appInfo = localStorage.getItem('record')
    if (appInfo) {
      appInfo = JSON.parse(appInfo)
      if (appInfo && appInfo.model_capability === 'textsummarization') {
        str = '文本摘要'
      }
    }
    return str
  }
  HeadersAllMenu = () => {
    this.formap(routes[0].children)
    setTimeout(() => {
      let Menu = JSON.parse(localStorage.getItem('Menu'))
      if (Menu) {
        // 在组件挂载后（插入 DOM 树中）立即调用
        const urlParams = new URL(window.location.href)
        const pathname = urlParams?.pathname
        this.initkey(pathname)
        Menu.openKeys = this.state.openKeys
        Menu.current = this.state.current
        if (Menu.menuList) {
          Menu.menuList = this.state.menuList
        }
        // 防止页面刷新导致菜单栏选中失效
        localStorage.setItem('Menu', JSON.stringify(Menu))
        let len = this.state.openKeys.length
        this.state.pathSnippets = pathname.split('/').filter((i) => i)
        if (pathname === '/') {
          this.setState({
            showback: false,
            title: ''
          })
        } else {
          if (
            this.state.openKeys[len - 1] === '/enginefactory' ||
            this.state.openKeys[0] === '/enginefactory'
          ) {
            if (len > 2) {
              let breadcrumbNameMap = this.setTitle()
              breadcrumbNameMap = this.handleSetTitle(breadcrumbNameMap)
              this.setState({
                showback: true,
                title: breadcrumbNameMap
              })
            } else {
              this.setState({
                showback: false,
                title: ''
              })
            }
          } else {
            let list = ['/promotion', '/engineservices']

            if (len > 1 || list.includes(pathname)) {
              let breadcrumbNameMap = this.setTitle()
              breadcrumbNameMap = this.handleSetTitle(breadcrumbNameMap)
              this.setState({
                showback: true,
                title: breadcrumbNameMap
              })
            } else {
              this.setState({
                showback: false,
                title: ''
              })
            }
          }
        }
      }
    }, 100)
  }
  onBack() {
    //console.log("pathname", window.location.pathname);
    window.history.go(-1)
  }
  onVisibleChange(value) {
    this.setState({
      isopenDown: value
    })
    this.triggerVisible()
  }
  triggerVisible(value) {
    if (this.state.isopenDown) {
      this.setState({
        istrigger: false
      })
    } else {
      this.setState({
        istrigger: value
      })
    }
  }
  render() {
    return (
      <Header id="layoutHeaders">
        <PageHeader
          style={{ background: 'transparent' }}
          title={this.state.title}
          subTitle=""
          backIcon={this.state.showback}
          onBack={this.props.onBack.bind(this)}
          extra={
            <div className="headeright dropdown-demo">
              <Space align={'center'}>
                {/* <Badge text="HOT" offset={[-14, 4]}>
                  <Link
                    onClick={() => {
                      let appInfo = JSON.parse(localStorage.getItem('record'))
                      localStorage.setItem('record', JSON.stringify(appInfo))
                    }}
                    style={{
                      boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.20)',
                      marginRight: 12,
                      padding: '13px 24px',
                      borderRadius: 14
                    }}
                    className="custom-White-button"
                  >
                    <Typography.Text className="end-title">
                      token指引
                    </Typography.Text>
                  </Link>
                </Badge> */}
                {/* <Link onClick={this.onBack.bind(this)} icon={<IconArrowLeft />}>{this.state.title}</Link> */}
                <Badge text="NEW" offset={[-14, 4]}>
                  <Link
                    href="/engineservices/billingmethod"
                    onClick={() => {
                      let appInfo = JSON.parse(localStorage.getItem('record'))
                      appInfo.show_id = ''
                      localStorage.setItem('record', JSON.stringify(appInfo))
                    }}
                    style={{
                      boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.20)',
                      marginRight: 12,
                      padding: '13px 24px',
                      borderRadius: 14
                    }}
                    className="custom-White-button"
                  >
                    <Typography.Text className="end-title">
                      产品价格
                    </Typography.Text>
                  </Link>
                </Badge>
                {/* <Link
                  href="/myapp/calldetails?type=home"
                  onClick={()=>{
                    let appInfo = JSON.parse(localStorage.getItem('record'));
                    appInfo.show_id = ''
                    localStorage.setItem('record', JSON.stringify(appInfo))
                  }}
                  icon={
                    <span
                      className="iconfont icon-icon_zhifuxinxi"
                      style={iconStyle}
                    ></span>
                  }
                  style={{
                    boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                    marginRight: 12,
                    padding: '13px 18px',
                    borderRadius: 14,
                  }}
                  className="custom-White-button"
                >
                  <Typography.Text className="end-title">
                    调用明细
                  </Typography.Text>
                </Link> */}
                <Trigger
                  popupVisible={this.state.visible2}
                  position="bottom"
                  popupAlign={{
                    bottom: 10
                  }}
                  popup={() => (
                    <div className="dropdown-box">
                      <Link
                        href="/payment/paymentdetail"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={
                          <svg
                            t="1735200093756"
                            className="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="7553"
                            width="12"
                            height="12"
                          >
                            <path
                              d="M832.16 224L832 640.032h32a32 32 0 0 1 32 32v106.912C896 825.696 854.784 864 804.032 864h-450.88C302.4 864 256 823.232 256 773.024V416H160a32 32 0 0 1-32-32V256a96 96 0 0 1 96-96h544.16c35.36 0 64 28.64 64 64zM256 349.76V256a32 32 0 1 0-64 0v93.76c0 2.016 1.184 3.008 2.336 3.008h59.328c1.568 0 2.336-1.504 2.336-2.976zM768.16 640V224H287.968A32 32 0 0 1 320 256v516.512c0 13.76 15.168 27.552 31.872 27.552 16.192 0 32.128-13.76 32.128-27.52V672a32 32 0 0 1 32-32h352.16z m31.68 160.096c17.28 0 32.32-15.424 32.32-34.304V704H448.128v55.328c0 12.416 0 22.496-4.032 28.32a53.536 53.536 0 0 1-13.536 12.48h369.28zM384 288h320v64H384V288z m0 128h320v64H384v-64z"
                              fill="#686C78"
                              p-id="7554"
                            ></path>
                          </svg>
                        }
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          账单管理
                        </Typography.Text>
                      </Link>
                      <Link
                        href="/payment/order"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={
                          <svg
                            t="1735199835443"
                            className="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="4279"
                            width="13"
                            height="13"
                          >
                            <path
                              d="M800.037628 928.016126 223.962372 928.016126c-52.980346 0-95.983874-43.003528-95.983874-95.983874l0-639.892491c0-52.980346 43.003528-95.983874 95.983874-95.983874l575.903242 0c52.980346 0 95.983874 43.003528 95.983874 95.983874l0 639.892491C896.021502 884.840585 852.84596 928.016126 800.037628 928.016126zM223.962372 159.973123c-17.545439 0-31.994625 14.449185-31.994625 31.994625l0 639.892491c0 17.717453 14.449185 31.994625 31.994625 31.994625l575.903242 0c17.717453 0 31.994625-14.277171 31.994625-31.994625l0-639.892491c0-17.545439-14.277171-31.994625-31.994625-31.994625L223.962372 159.973123z"
                              fill="#575B66"
                              p-id="4280"
                            ></path>
                            <path
                              d="M640.924576 544.768688 287.779607 544.768688c-17.717453 0-31.994625-14.277171-31.994625-31.994625 0-17.717453 14.277171-31.994625 31.994625-31.994625l353.144969 0c17.717453 0 31.994625 14.277171 31.994625 31.994625C672.9192 530.491517 658.642029 544.768688 640.924576 544.768688z"
                              fill="#575B66"
                              p-id="4281"
                            ></path>
                            <path
                              d="M734.84428 735.532337l-447.236687 0c-17.717453 0-31.994625-14.277171-31.994625-31.994625s14.277171-31.994625 31.994625-31.994625l447.236687 0c17.717453 0 31.994625 14.277171 31.994625 31.994625S752.561734 735.532337 734.84428 735.532337z"
                              fill="#575B66"
                              p-id="4282"
                            ></path>
                            <path
                              d="M255.784982 305.325046c0 26.490173 21.501764 47.991937 47.991937 47.991937s47.991937-21.501764 47.991937-47.991937-21.501764-47.991937-47.991937-47.991937S255.784982 278.834873 255.784982 305.325046z"
                              fill="#575B66"
                              p-id="4283"
                            ></path>
                            <path
                              d="M463.061986 305.325046c0 26.490173 21.501764 47.991937 47.991937 47.991937s47.991937-21.501764 47.991937-47.991937-21.501764-47.991937-47.991937-47.991937S463.061986 278.834873 463.061986 305.325046z"
                              fill="#575B66"
                              p-id="4284"
                            ></path>
                            <path
                              d="M671.199059 305.325046c0 26.490173 21.501764 47.991937 47.991937 47.991937s47.991937-21.501764 47.991937-47.991937-21.501764-47.991937-47.991937-47.991937S671.199059 278.834873 671.199059 305.325046z"
                              fill="#575B66"
                              p-id="4285"
                            ></path>
                          </svg>
                        }
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          订单管理
                        </Typography.Text>
                      </Link>
                      <Link
                        href="/payment/breakdown"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={
                          <svg
                            t="1736392450748"
                            className="icon"
                            viewBox="0 0 1034 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="12317"
                            width="13"
                            height="13"
                          >
                            <path
                              d="M213.258552 597.162336a28.344896 28.344896 0 0 0-24.633826 42.61332 28.536848 28.536848 0 0 0 24.633826 14.268424h127.967928a28.472864 28.472864 0 0 0 0-56.881744h-127.967928z m526.076152-142.172368a284.280752 284.280752 0 0 0 0 568.433536 284.280752 284.280752 0 1 0 0-568.433536z m0 511.551792A227.59096 227.59096 0 0 1 511.871712 739.27072a227.782912 227.782912 0 0 1 227.462992-227.462992 227.782912 227.782912 0 0 1 227.526976 227.462992 227.654944 227.654944 0 0 1-227.526976 227.27104z m-281.785377 0.255936H113.891456a57.073696 57.073696 0 0 1-57.073696-56.945728V113.827472c0-31.352142 25.593586-56.945728 56.881744-56.945728h710.86184c31.416126 0 56.945728 25.33765 56.945728 56.625808v284.600672a28.40888 28.40888 0 1 0 56.881744 0V113.507552A113.891456 113.891456 0 0 0 824.625328 0H113.763488C51.123187 0 0 51.059203 0 113.827472v796.08848A113.699504 113.699504 0 0 0 113.95544 1023.743424h343.593887a28.472864 28.472864 0 1 0 0-56.945728z m78.956211-526.076152A28.536848 28.536848 0 0 0 511.871712 398.108224H213.258552a28.344896 28.344896 0 0 0-24.633826 42.61332 28.536848 28.536848 0 0 0 24.633826 14.268424H511.871712a28.472864 28.472864 0 0 0 24.633826-14.268424z m217.73743-213.194568a28.344896 28.344896 0 0 0-28.40888-28.40888h-512.511552a28.344896 28.344896 0 0 0-24.633826 42.677304 28.344896 28.344896 0 0 0 24.569842 14.140456h512.511552a28.40888 28.40888 0 0 0 28.472864-28.40888z m98.79124 448.591572h-44.212919l52.082947-47.860005a19.835029 19.835029 0 1 0-26.937249-29.240672l-84.074929 77.100677h-21.882515l-84.010945-77.100677a19.962997 19.962997 0 0 0-27.705057 1.663583 19.835029 19.835029 0 0 0 0.767808 27.577089l52.082947 47.860005h-43.57308a19.962997 19.962997 0 0 0 0 39.925993h93.864475v67.31113H634.464987a19.707061 19.707061 0 0 0-17.851526 9.661579 19.899013 19.899013 0 0 0 17.851526 30.008479h84.970704v58.225407a19.835029 19.835029 0 0 0 29.880512 17.339655 19.899013 19.899013 0 0 0 9.917514-17.339655v-58.225407h84.90672c11.069226 0 20.026981-8.957755 20.026981-19.899013a19.962997 19.962997 0 0 0-20.026981-19.899012h-84.90672V715.980557h93.864475a20.090965 20.090965 0 1 0 14.140456-34.039468 20.730804 20.730804 0 0 0-14.20444-5.822541z"
                              fill="#888888"
                              p-id="12318"
                            ></path>
                          </svg>
                        }
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          消费明细
                        </Typography.Text>
                      </Link>
                      <Link
                        href="/payment/details"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={
                          <svg
                            t="1735200025685"
                            className="icon"
                            viewBox="0 0 1034 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="6365"
                            width="13"
                            height="13"
                          >
                            <path
                              d="M988.16 312.32c5.12 5.12 5.12 15.36 5.12 20.48h-56.32c-71.68-163.84-235.52-281.6-424.96-281.6-256 0-460.8 204.8-460.8 460.8h-51.2c0-281.6 230.4-512 512-512 184.32 0 343.04 97.28 435.2 240.64l15.36-87.04c0-15.36 15.36-25.6 30.72-20.48 15.36 0 25.6 15.36 20.48 30.72l-25.6 148.48z m-942.08 399.36c-5.12-5.12-5.12-15.36-5.12-20.48h56.32c71.68 163.84 235.52 281.6 424.96 281.6 256 0 460.8-204.8 460.8-460.8h51.2c0 281.6-230.4 512-512 512-184.32 0-343.04-97.28-435.2-240.64l-15.36 87.04c0 15.36-15.36 25.6-30.72 20.48-15.36 0-25.6-15.36-20.48-30.72l25.6-148.48z"
                              fillOpacity=".65"
                              p-id="6366"
                            ></path>
                            <path
                              d="M542.72 849.92s0 15.36-20.48 15.36c-10.24 0-25.6-5.12-25.6-15.36v-76.8c-76.8 0-148.48-51.2-174.08-128-5.12-5.12-5.12-15.36 0-20.48 0-5.12 5.12-10.24 10.24-15.36h5.12c15.36-5.12 30.72 0 40.96 15.36 15.36 51.2 66.56 92.16 117.76 92.16v-189.44c-46.08-5.12-87.04-25.6-117.76-61.44-20.48-20.48-30.72-51.2-30.72-81.92 0-81.92 51.2-128 148.48-143.36v-66.56c5.12-10.24 10.24-15.36 25.6-20.48 10.24 0 20.48 5.12 25.6 20.48v66.56c66.56 0 128 40.96 153.6 107.52 0 10.24-10.24 20.48-20.48 25.6-10.24 5.12-25.6 0-35.84-5.12-15.36-40.96-56.32-71.68-102.4-71.68v168.96c112.64 20.48 163.84 71.68 163.84 148.48 0 35.84-15.36 71.68-35.84 97.28-35.84 35.84-81.92 51.2-128 56.32v81.92z m-46.08-547.84c-25.6 0-46.08 10.24-66.56 25.6-15.36 15.36-25.6 35.84-25.6 56.32 0 46.08 30.72 71.68 92.16 81.92v-163.84z m46.08 409.6c25.6 0 56.32-10.24 76.8-25.6 15.36-15.36 25.6-35.84 25.6-61.44 0-51.2-35.84-81.92-102.4-87.04v174.08z"
                              fillOpacity=".65"
                              p-id="6367"
                            ></path>
                          </svg>
                        }
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          收支流水
                        </Typography.Text>
                      </Link>
                      <Link
                        href="/payment/administration"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={
                          <svg
                            t="1735200176981"
                            className="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="8738"
                            width="13"
                            height="13"
                          >
                            <path
                              d="M876.316444 0H146.090667C83.683556 0 28.330667 24.291556 28.444444 102.627556v781.084444c0 101.831111 49.948444 139.832889 87.04 139.832889 37.034667 0 134.997333-113.720889 134.997334-113.720889S331.150222 1024 381.724444 1024c50.517333 0 117.76-114.176 117.76-114.176s89.884444 113.720889 142.677334 113.720889c58.766222 0 116.451556-113.720889 116.451555-113.720889s64.853333 114.176 118.158223 112.184889c31.744-4.551111 46.819556-10.865778 63.658666-35.612445l1.877334-2.844444a186.936889 186.936889 0 0 0 28.273777-99.726222V128.455111C970.524444 49.948444 934.001778 0 876.316444 0z m36.864 895.544889c0 21.219556-9.272889 69.688889-39.537777 68.608-21.902222-0.739556-89.144889-108.942222-89.144889-108.942222-7.566222-15.018667-22.926222-23.665778-38.286222-21.504a38.570667 38.570667 0 0 0-27.875556 20.650666s-53.475556 109.112889-77.596444 109.112889c-24.007111 0-108.487111-109.112889-108.487112-109.112889a38.570667 38.570667 0 0 0-23.153777-19.569777 34.816 34.816 0 0 0-19.456 0 39.196444 39.196444 0 0 0-23.096889 19.683555s-60.529778 108.999111-84.878222 108.999111c-24.405333 0-100.010667-108.885333-100.010667-108.885333a38.513778 38.513778 0 0 0-23.153778-19.683556 35.612444 35.612444 0 0 0-4.835555-1.080889 37.546667 37.546667 0 0 0-38.001778 21.504s-82.033778 108.088889-96.426667 108.828445c-21.162667 1.137778-34.019556-44.088889-34.019555-68.551111V134.257778c-1.080889-43.804444 34.247111-77.141333 71.111111-77.141334H842.524444c27.477333 0 70.656 20.764444 70.656 77.084445v761.400889zM236.202667 274.033778H508.586667a28.444444 28.444444 0 0 0 28.387555-28.558222 28.444444 28.444444 0 0 0-28.444444-28.558223H236.259556a28.444444 28.444444 0 0 0-28.444445 28.558223 28.444444 28.444444 0 0 0 28.444445 28.558222z m0 194.446222h379.050666a28.444444 28.444444 0 0 0 28.444445-28.558222 28.444444 28.444444 0 0 0-28.444445-28.558222H236.202667a28.444444 28.444444 0 0 0-28.444445 28.558222 28.444444 28.444444 0 0 0 28.444445 28.558222z m524.344889 137.329778H236.202667a28.444444 28.444444 0 0 0-28.444445 28.558222 28.444444 28.444444 0 0 0 28.444445 28.558222h524.344889a28.444444 28.444444 0 0 0 28.387555-28.558222 28.444444 28.444444 0 0 0-28.387555-28.558222z"
                              fill="#606266"
                              p-id="8739"
                            ></path>
                          </svg>
                        }
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          发票管理
                        </Typography.Text>
                      </Link>

                      {/* <Link
                        href="/payment/general"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={<IconUserGroup />}
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          账户充值
                        </Typography.Text>
                      </Link> */}
                    </div>
                  )}
                  trigger="hover"
                  classNames="zoomInTop"
                  onVisibleChange={(visible) => {
                    this.setState({ visible2: visible })
                  }}
                >
                  <Link
                    style={{
                      boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                      marginRight: 12,
                      padding: '13px 18px',
                      borderRadius: 14
                    }}
                    className="custom-White-button"
                  >
                    <Typography.Text className="end-title">
                      财务中心
                      <IconDown style={{ fontSize: 12, marginLeft: 6 }} />
                    </Typography.Text>
                  </Link>
                </Trigger>
                <Link
                  href="/payment"
                  onClick={() => {
                    let appInfo = JSON.parse(localStorage.getItem('record'))
                    appInfo.show_id = ''
                    localStorage.setItem('record', JSON.stringify(appInfo))
                  }}
                  icon={<IconUserGroup />}
                  style={{
                    boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                    marginRight: 12,
                    padding: '13px 18px',
                    borderRadius: 14
                  }}
                  className="custom-White-button"
                >
                  <Typography.Text className="end-title">
                    账户总览
                  </Typography.Text>
                </Link>
                {/* 原资源管理 */}
                {/* <Trigger
                  popupVisible={this.state.visible}
                  position="bottom"
                  popupAlign={{
                    bottom: 10
                  }}
                  popup={() => (
                    <div className="dropdown-box">
                      <Link
                        href="/payment"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={<IconUserGroup />}
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          账户充值
                        </Typography.Text>
                      </Link>

                      <Link
                        href="/myapp/calldetails?type=home"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={
                          <span
                            className="iconfont icon-icon_zhifuxinxi"
                            style={iconStyle}
                          ></span>
                        }
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          资源购买
                        </Typography.Text>
                      </Link>

                      <Link
                        href="/myapp/calldetails?type=home"
                        onClick={() => {
                          let appInfo = JSON.parse(
                            localStorage.getItem('record')
                          )
                          appInfo.show_id = ''
                          localStorage.setItem(
                            'record',
                            JSON.stringify(appInfo)
                          )
                        }}
                        icon={<IconFile />}
                        style={{
                          boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                          marginRight: 12,
                          padding: '13px 18px',
                          borderRadius: 14
                        }}
                        className="custom-White-button"
                      >
                        <Typography.Text className="end-title">
                          调用明细
                        </Typography.Text>
                      </Link>
                    </div>
                  )}
                  trigger="hover"
                  classNames="zoomInTop"
                  onVisibleChange={(visible) => {
                    this.setState({ visible: visible })
                  }}
                >
                  <Link
                    style={{
                      boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                      marginRight: 12,
                      padding: '13px 18px',
                      borderRadius: 14
                    }}
                    className="custom-White-button"
                  >
                    <Typography.Text className="end-title">
                      资源管理
                      <IconDown style={{ fontSize: 12, marginLeft: 6 }} />
                    </Typography.Text>
                  </Link>
                </Trigger> */}

                {/* <Link
                  href="/payment"
                  icon={
                    <span
                      className="iconfont icon-icon_zhifuxinxi"
                      style={iconStyle}
                    ></span>
                  }
                  style={{
                    boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                    marginRight: 12,
                    padding: '13px 18px',
                    borderRadius: 14,
                  }}
                  className="custom-White-button"
                >
                  <Typography.Text className="end-title">
                    资源费用
                  </Typography.Text>
                </Link> */}
                {/* <Link
                  href="/echnicalsupport"
                  icon={<IconFile />}
                  style={{
                    boxShadow: '0px 6px 58px 0px rgba(196,203,214,0.10)',
                    marginRight: 12,
                    padding: '13px 18px',
                    borderRadius: 14
                  }}
                  className="custom-White-button"
                >
                  <Typography.Text className="end-title">
                    技术支持
                  </Typography.Text>
                </Link> */}
                <Dropdown
                  triggerProps={{ autoAlignPopupWidth: true }}
                  trigger="click"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onVisibleChange={this.onVisibleChange.bind(this)}
                  droplist={
                    <Menu className="header-menu">
                      <Menu.Item key="1">
                        <Link
                          href="/personalcenter"
                          hoverable={false}
                          style={{ color: '#0a1629' }}
                        >
                          <IconUser style={iconStyle} />
                          个人中心
                        </Link>
                      </Menu.Item>
                      {/* <Menu.Item
                        style={{
                          display:
                            this.state.identity &&
                            this.state.identity !== 'PERSONAL'
                              ? 'block'
                              : 'none',
                        }}
                        key="2"
                        onClick={this.props.AccessManager.bind(this)}
                      >
                        <Link hoverable={false} style={{ color: '#0a1629' }}>
                          <IconLock style={iconStyle} />
                          访问管理
                        </Link>
                      </Menu.Item> */}
                      {this.state.has_enterprise ? (
                        <Menu.Item
                          key="3"
                          onClick={this.props.switchAccounts.bind(this)}
                        >
                          <Link hoverable={false} style={{ color: '#0a1629' }}>
                            <IconSwap style={iconStyle} />
                            {this.state.identity === 'PERSONAL'
                              ? '切换企业账户'
                              : '切换普通账户'}
                          </Link>
                        </Menu.Item>
                      ) : (
                        ''
                      )}
                      <Menu.Item
                        key="4"
                        onClick={this.props.setoutAuth.bind(this)}
                      >
                        <Link hoverable={false} style={{ color: '#0a1629' }}>
                          <IconExport style={iconStyle} />
                          退出登录
                        </Link>
                      </Menu.Item>
                    </Menu>
                  }
                  position="br"
                >
                  <Button
                    className="custom-select"
                    id="infoselect"
                    style={{ height: 48, padding: '0 13px', borderRadius: 14 }}
                  >
                    <div className="rowCenter">
                      <Avatar
                        size={20}
                        shape="square"
                        style={{ marginRight: 17 }}
                      >
                        {this.state.avatar ? (
                          <img
                            alt="avatar"
                            id="headeravatar"
                            style={{ height: 'auto' }}
                            src={this.state.avatar}
                            onError={(e) => {
                              e.target.src = this.state.avatar
                            }}
                          />
                        ) : (
                          <img
                            alt="avatar"
                            id="headeravatar"
                            style={{ height: 'auto' }}
                            src={default_avart}
                          />
                        )}
                      </Avatar>
                      <Typography.Text ellipsis className="username-ellipsis">
                        {this.state.username || '优小优xxx'}
                      </Typography.Text>
                    </div>
                    {this.state.identity ? (
                      <Trigger
                        popup={() => <Popup />}
                        position="br"
                        popupAlign={{ bottom: 30 }}
                        onVisibleChange={this.triggerVisible.bind(this)}
                        popupVisible={this.state.istrigger}
                        trigger={['hover']}
                        clickToClose={false}
                        classNames="zoomInTop"
                        disabled={
                          !(
                            this.state.identity === 'PERSONAL' ||
                            !this.state.identity
                          )
                        }
                      >
                        {/* <div
                          className={`skew-x ${
                            this.state.identity === 'PERSONAL' ||
                            !this.state.identity
                              ? 'bule'
                              : ''
                          }`}
                        >
                          <div className="AlibabaPuHuiTi-Medium">
                            VIP
                            {this.state.vip_level > 0
                              ? this.state.vip_level
                              : ''}
                          </div>
                        </div> */}
                      </Trigger>
                    ) : (
                      ''
                    )}
                    <IconDown style={{ marginLeft: 20 }} />
                  </Button>
                </Dropdown>
              </Space>
            </div>
          }
        />
      </Header>
    )
  }
}

export default Headers
